/**
 * Error for option contracts that are not listed / not found upstream.
 * Maps to Excel #N/A "Not listed" (not #CONNECT).
 */

export class NotListedError extends Error {
  readonly name = "NotListedError";

  constructor(message: string = "Not listed") {
    super(message);
    Object.setPrototypeOf(this, NotListedError.prototype);
  }
}
